import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ProgressBar from "./ProgressBar";

import './ProgressBar.css'

function ProgressBarContainer(props) {
    const [percentRange,setPercentRange] = useState(null);

    useEffect(() => {
        let interval;
        if(props.duration){
            const slideRate = 10;
            const duration = props.duration;
            const downward = props.downward;
            let percentage = downward?100:0;
            const increment = (100/(duration/1000)*(downward?-1:1))/10;
            console.log(increment)
            interval = setInterval(() => {
                setPercentRange(percentage);
                percentage+=(increment);
                //console.log(percentage)
                if( (downward && percentage <= 0) || (!downward && percentage >= 100) ){
                    clearInterval(interval);
                }
            }, 100);
        }

        return () => {
            if(interval) {
                clearInterval(interval);
            }
        }

    },[] )

    return (
        <div >
        {((props.duration && percentRange) || props.percentRange) && 
            <ProgressBar percentRange={percentRange || props.percentRange}/>
        }
        </div>
    );
}

export default ProgressBarContainer;